export default __webpack_public_path__ + "static/media/construct-management.e0391014.jpg";